import type { Address } from 'viem'

import { orpc } from '@/lib/orpc/client'

import { PAGE_SIZE } from './config'

/** Above 0, so the page the server loaded is not refetched as soon as the page hydrates. */
const REALLOCATIONS_STALE_TIME_MS = 60_000

/**
 * One set of options for the server's first page and the client's pages, so their keys match.
 * The first page has no cursor.
 */
export function reallocationsQueryOptions({
  chainId,
  address,
  cursor
}: {
  chainId: number
  address: Address
  cursor?: string
}) {
  return orpc.vaultV1.reallocations.queryOptions({
    input: { chainId, address, limit: PAGE_SIZE, ...(cursor === undefined ? {} : { cursor }) },
    staleTime: REALLOCATIONS_STALE_TIME_MS
  })
}
